import Vue from 'vue';
import { initGlobalState } from 'qiankun';
import store from '@/store';

// 初始化主应用和子应用的通信
// 文档：https://qiankun.umijs.org/zh/api#initglobalstatestate
export function initState() {
  // 定义通信时的字段
  const initialState = {
    notifySuccess: 'primary',
    appCard: '',
  };
  const actions = initGlobalState(initialState);
  // 挂载主应用给子应用发消息的方法
  Vue.prototype.$setGlobalState = actions.setGlobalState;
  
  // 接收子应用的消息
  actions.onGlobalStateChange((state) => {
    store.commit('user/updateGlobalState', state);
  });
}

initState();
